import {
	DashboardReportType,
	ReportsApprovedResponse,
} from "../../../types/dashboard.types";
import { REPORT_TYPES } from "../dashboardConfig";

export const APPROVED_TITLE = "Reports approved";

export const approvedEmptyText = (year: number) =>
	`No approved reports in ${year}`;

/** Types the tenant enables, in display order; `onlyTypes` narrows them. */
export const approvedTypes = (
	data: ReportsApprovedResponse,
	onlyTypes: DashboardReportType[] = []
) =>
	REPORT_TYPES.filter(
		(type) =>
			data.types.includes(type.key) &&
			(!onlyTypes.length || onlyTypes.includes(type.key))
	);

export const sumTypes = (
	counts: Partial<Record<DashboardReportType, number>>,
	types: DashboardReportType[]
) => types.reduce((sum, type) => sum + (counts[type] ?? 0), 0);

export const hasNoApproved = (
	data: ReportsApprovedResponse,
	onlyTypes?: DashboardReportType[]
) =>
	sumTypes(
		data.byType,
		approvedTypes(data, onlyTypes).map((type) => type.key)
	) === 0;
